
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M2.89 12.32H57.1V58.5H2.89z"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M10.77 12.58V1.5h18.02v11.08M32.44 4.49l-3.65.04M10.77 4.72l-3.66.04M42.94 27.52h5.87V50.3H11.19V27.52h17.88M42.7 20.09h7.1M10.2 20.09h18.39"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M29.01 17.68h13.68v22.16H29.01zM29.38 34.01h12.73"}})])
          )
        }
      }
    